<template>
  <!--我的訂單-->
  <div v-if="orderItem">
    <div class="loadingInf">
      <img @click="$router.push('/profile/my-order')" class="back"
           :src="require('@/assets/homeImg/wdzh_wddd_icon_fanhui@2x.png')" alt="">
      <span>
        {{$t('mall_order_detail.order_detail')}}<!-- 訂單詳情 -->
      </span>
      <span class="total">
        {{$t('mall_order_detail.order_num')}}<!-- 訂單編號 -->：{{ orderItem.invoice_no_str }}</span>
    </div>
    <div class="scrollBox">
      <div class="selfOrder">
        <div class="timeBox">
          <div class="date">{{ orderItem.created_at }}</div> <!--訂單創建時間-->
          <div class="finish">
            <span>{{ orderItem.order_status }}</span>  <!--訂單狀態-->
          </div>
        </div>
        <div class="orderList">
          <div style="margin-bottom: 20px;" v-for="product in orderItem.order_purchase_products" :key="product.id">
            <div class="orderImg">
              <img :src="imgUrl + product.product_model.path" alt="">  <!--產品圖片-->
            </div>
            <div class="orderDetail">
              <div class="name">
                <span>{{ product.product_model.default_name }}</span> <!--產品名稱-->
                <span class="count"></span>
              </div>
              <div class="orderRight">
                <div class="orderInf">
                  <div>
                    <span>
                     {{ $t('mall_detail.color') }} :    <!-- 顏色 -->
                    </span>
                    <span>{{ product.product_model.color_photo[0].color.name }}</span>
                  </div>
                  <div>
                    <span>
                     {{ $t('mall_detail.size') }} :  <!-- 尺寸 -->
                    </span>
                    <span>{{
                        product.product_size === '0'
                          ? $t('mall_detail.free_size')
                          : product.product_size + $t('mall_detail.free_num')
                      }}
                    </span>
                  </div>
                </div>
                <div class="price">${{ product.total|PriceFormat }}</div>
              </div>
            </div>
          </div>
          <div v-if="orderItem.order_ship.ship_method.code==='O_MD'" class="addr">
            <div class="orderAddr">&nbsp{{
                orderItem.order_ship.ship_method.name
              }}：{{ orderItem.order_ship.store.name }}
            </div>
            <div><img style="width: 26px;height: 26px"
                      :src="require('@/assets/img/order_detail/icon_order_detail_time.png')" alt="">
              {{ orderItem.order_ship.store.business_time }}
            </div>
            <div><img style="width: 26px;height: 26px"
                      :src="require('@/assets/img/order_detail/icon_order_detail_address.png')" alt="">
              {{ orderItem.order_ship.store.address }}
            </div>
            <div><img style="width: 26px;height: 26px"
                      :src="require('@/assets/img/order_detail/icon_order_detail_phone.png')" alt="">
              {{ orderItem.order_ship.store.mobile }}
            </div>
          </div>
          <div v-else class="addr">
            <div class="orderAddr">{{ orderItem.order_ship.ship_method.name }}：</div>
            <div><img :src="require('@/assets/img/order_detail/icon_order_detail_name.png')" alt="">
              {{$t('mall_order_detail.receiver')}}<!-- 收件人 -->&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {{ orderItem.order_ship.order_shipping_address.name }}
            </div>
            <div><img :src="require('@/assets/img/order_detail/icon_order_detail_phone.png')" alt="">
              {{$t('mall_order_detail.phone_num')}}<!-- 收件號碼 -->&nbsp;&nbsp;&nbsp;&nbsp;
              {{ orderItem.order_ship.order_shipping_address.mobile }}
            </div>
            <div><img :src="require('@/assets/img/order_detail/icon_order_detail_address.png')" alt="">
              {{$t('mall_order_detail.address')}}<!-- 配送地址 -->&nbsp;&nbsp;&nbsp;&nbsp;
              {{
                orderItem.order_ship.order_shipping_address.address_pca + orderItem.order_ship.order_shipping_address.address
              }}
            </div>
          </div>
          <div class="unitPrice">
            <div style="margin-bottom: 10px;" v-for="payItem in orderItem.bottom_pay">
              <div>{{ payItem.name }}</div>
              <div>{{ payItem.prefix + payItem.flag }}<span>{{ payItem.value|PriceFormat }}</span></div>
            </div>
          </div>
          <div class="totalAmount ">
            <div>
             {{$t('mall_order_detail.total')}} <!-- 總價 -->
            </div>
            <div>${{ orderItem.real_pay|PriceFormat }}</div>
          </div>
          <router-link :to="{name:'PayOrder',params:{id:orderItem.id}}">
            <button v-show="orderItem.is_completed==='n'" class="btn2Pay">
              {{$t('mall_order_detail.pay')}}<!-- 立即支付 -->
            </button>
          </router-link>
          <button v-show="orderItem.is_completed==='n'" class="btn2Cancel" @click="cancelOrder()">
            {{$t('mall_order_detail.cancel')}}<!-- 取消訂單 -->
          </button>
          <div class="contact" style="clear: both">
            <div>
             {{$t('mall_order_detail.service')}} <!-- 如需退款/退貨，請聯繫客服 -->
              <img :src="require('@/assets/homeImg/wdzh_wddd_icon_lianxi@2x.png')" alt="">(852)
              2508-0998
            </div>
            <!--<div>(86) 0755-2590-1884</div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseUrl from '@/api/baseUrl.js'
import PriceFormat from '@/assets/js/PriceFormat';

export default {
  name: "OrderDetail",
  data() {
    return {
      imgUrl: baseUrl.imgUrl,
      orderId: this.$route.query.id,
      orderItem: null
    }
  },
  filters: {
    PriceFormat(val) {
      return PriceFormat(val);
    }
  },
  methods: {
    getOrderDetail() {
      this.$axios.get('mall_api/order_detail/' + this.orderId, {
        headers: {
          'language': this.language
        }
      }).then(res => {
        // console.log("getOrderDetail", res.data.data.order_purchase_products[0].product_size);
        this.orderItem = res.data.data;
      })
    },
    //  取消订单
    cancelOrder() {
      this.$axios.post('mall_api/trans/abort_purchase', {
        'order_purchase_id': this.orderId
      }).then(res => {
        this.$notify.success({
          title: this.$t('mall_order.order_cancel')//'成功取消訂單'
        });
        this.$router.go(-1);//返回上一层
      })
    }
  },
  mounted() {
    this.getOrderDetail();
  }
}
</script>

<style scoped>
.rightBox {
  width: 100%;
  min-height: 906px;
  padding: 30px;
  /*border: 1px solid #ddd;*/
  /*margin: 30px 0 30px 30px;*/
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  margin-bottom: 0;
  /*margin-bottom: 30px;*/
}

.loadingInf {
  color: #1E1303;
  font-size: 18px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.total {
  color: #979694;
  font-size: 14px;
  margin-left: 10px;
}

.selfOrder {
  width: 100%;
  /*height: 85%;*/
  padding: 20px 20px 0 20px;
  /*border: 1px solid #ddd;*/
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin-bottom: 20px;
  /*position: absolute;*/
  /*overflow: scroll;*/

}

.scrollBox {
  position: relative;
  /*width: 93%;*/
  /*height: 85%;*/
  /*overflow-y: scroll;*/
}

.timeBox {
  color: #7A7977;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.finish {
  color: #979694;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.finish > img {
  width: 10px;
  height: 10px;
}

.back {
  width: 9px;
  height: 18px;
  margin-right: 10px;
}

.orderList {
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 100px;
}

.orderList > div {
  display: flex;
  flex-direction: row;
}

.orderImg {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  width: 119px;
  height: 100px;
  border: 1px solid #ddd;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 5px;
  margin-right: 20px;

  /*-webkit-box-sizing: border-box;*/
  /*-moz-box-sizing: border-box;*/
  /*box-sizing: border-box;*/
}

.orderImg > img {
  width: 100%;
}

.orderDetail {
  color: #979694;
  font-size: 14px;
  width: 100%;
  /*margin-left: 20px;*/
  margin-right: 20px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border-bottom: 1px solid #ddd;
}

.name {
  color: #5B5957;
  font-size: 16px;
  padding-bottom: 10px;
}

.count {
  color: #979694;
  font-size: 14px;
}

.orderRight {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.price {
  color: #3E3C39;
  font-size: 18px;
}

.addr, .unitPrice, .contact {
  color: #7A7977;
  font-size: 14px;
}

.addr {
  display: flex;
  flex-direction: column !important;
  border-bottom: 1px solid #ddd;
}

.addr > div {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 0;
}

.addr > div > img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.contact > div > img {
  width: 16px;
  height: 16px;
}

.orderAddr {
  color: #3E3C39;
  font-size: 20px;
}

.unitPrice {
  flex-direction: column !important;
  padding: 20px 0;
  border-bottom: 1px solid #ddd;
}

.unitPrice > div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.totalAmount {
  color: #5B5957;
  font-size: 20px;
  display: flex;
  flex-direction: row !important;
  justify-content: space-between;
  padding: 20px 0;
  /*margin-bottom: 10px;*/
  /*border-bottom: 1px solid #ddd;*/
}

.contact {
  flex-direction: column !important;
  align-items: flex-end;
  justify-content: center;
}

.contact > div:first-child {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 0;
}

.contact > div:first-child > img {
  margin: 0 10px;
}

.btn2Pay {
  width: 112px;
  height: 40px;
  color: white;
  font-size: 16px;
  background: black;
  text-align: center;
  float: right;
  border: none;
}

.btn2Cancel {
  width: 112px;
  height: 40px;
  color: black;
  font-size: 16px;
  background: white;
  text-align: center;
  float: right;
  margin-right: 20px;
  border: 1px solid black;
}

</style>



// WEBPACK FOOTER //
// src/views/viewHK/MyProfile/OrderDetail.vue